import { useTheme } from "@/theme/ThemeProvider";
import { Pressable, Text, View, type ViewStyle } from "react-native";

export type WorkTab = {
  id: string;
  label: string;
  panel: React.ReactNode;
};

/**
 * Ruhige Arbeits-Tabs (Unterstrich, kompakt) – für Tierakte u.ä.
 * Kein File-Folder-Look, kein eigener Scroll-Container (Screen scrollt).
 */
export function WorkTabs({
  tabs,
  activeId,
  onSelect,
  style,
}: {
  tabs: WorkTab[];
  activeId: string;
  onSelect: (id: string) => void;
  style?: ViewStyle;
}) {
  const { theme } = useTheme();
  const activeTab = tabs.find((t) => t.id === activeId) ?? tabs[0];

  return (
    <View style={[{ gap: theme.space.md }, style]}>
      <View
        style={{
          flexDirection: "row",
          flexWrap: "wrap",
          gap: theme.space.sm,
          borderBottomWidth: 1,
          borderBottomColor: theme.color.border,
        }}
      >
        {tabs.map((tab) => {
          const active = tab.id === activeId;
          return (
            <Pressable
              key={tab.id}
              onPress={() => onSelect(tab.id)}
              role="tab"
              aria-selected={active}
              accessibilityLabel={tab.label}
              hitSlop={12}
              style={{
                minHeight: 44,
                justifyContent: "center",
                paddingVertical: theme.space.sm,
                paddingHorizontal: 2,
                marginBottom: -1,
                borderBottomWidth: 2,
                borderBottomColor: active
                  ? theme.color.primary
                  : "transparent",
              }}
            >
              <Text
                style={{
                  color: active ? theme.color.primary : theme.color.textSecondary,
                  fontSize: theme.fontSize.small,
                  fontWeight: active ? "700" : "600",
                  paddingHorizontal: theme.space.xs,
                }}
                numberOfLines={1}
              >
                {tab.label}
              </Text>
            </Pressable>
          );
        })}
      </View>
      <View>{activeTab?.panel}</View>
    </View>
  );
}
